import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getOrdersApi } from '../../../api/orders/orders';
import { ACL, PAGE_CONTEXTS } from '../../../config/constants';
import { hideSpinner, showSpinner } from "../../../store/actions/loading";
import { Paginator } from '../../layout/Paginator/Paginator';
import { Search } from '../../layout/Table/Search';
import { TableComponent } from "./table/Table";
import { store } from '../../../store/store';
import { hideNotification } from '../../../store/actions/notification';
import { AutoRefreshTable } from "../../layout/Table/AutoRefreshTable";
import { RowsPerPage } from "../../layout/Table/RowsPerPage";
import { ListToolbar } from '../../layout/Workspace';

let oneTimeCall = false;
function OrderTableComponent(props) {
  const [ sortDirection, setSortDirection ] = useState( null );
  const [ sortField, setSortField ] = useState( null );
  const [ searchText, setSearchText ] = useState( null );
  const [ orders, setOrders ] = useState( null );
  const [ meta, setMeta ] = useState( null );
  const [ rowsPerPage, setRowsPerPage ] = useState( 10 );

  useEffect( () => {
    getOrders( 1 );

    return () => {
      store.dispatch(hideNotification());
    }
  }, [] ); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect( () => {
      getOrders(1, sortField, sortDirection, searchText);

    return () => {
      store.dispatch(hideNotification());
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rowsPerPage] );

  /**
   * Get orders
   * @param {number} [page]
   * @param {string} [sortField]
   * @param {string} [sortDirection]
   * @param {string} [searchText]
   */
  const getOrders = (page, sortField, sortDirection, searchText, hideNotification = false) => {
    if (! ACL.CLIENT.ORDERS.LIST.hasAccess() || oneTimeCall === true) {
      return;
    }

    oneTimeCall = true;

    getOrdersApi( {
      pagination: {
        page: page,
        sort_by: sortField,
        sort: sortDirection,
        q: searchText,
        per_page: rowsPerPage,
        page_context: PAGE_CONTEXTS.ORDERS.LIST
      },
      hideNotification: hideNotification
    } ).then(
      response => {
        if (! response || ! response.data) {
          return;
        }

        setOrders( response.data );
        setMeta( response.meta );
        props.hideSpinner();
      }
    ).finally(() => {
      oneTimeCall = false;
    });

  };

  /**
   * Apply sort by appliedSortField
   * @param {string} appliedSortField
   */
  function applySort(appliedSortField) {
    let newSortDirection = "";

    if (sortField) {
      if (sortField === appliedSortField) {
        newSortDirection = sortDirection === "asc" ? "desc" : "asc";
      } else {
        newSortDirection = "asc";
      }
    } else {
      newSortDirection = "asc";
    }

    setSortField( appliedSortField );
    setSortDirection( newSortDirection );

    getOrders( meta.current_page, appliedSortField, newSortDirection, searchText, true );

  }

  return (
    <div className="orders-list-layout">
      <ListToolbar
        className="orders-list-toolbar"
        search={ACL.CLIENT.ORDERS.SEARCH.hasAccess() ? (
          <Search
            search={searchText => {
              setSearchText( searchText );
              getOrders( 1, null, null, searchText, true );
            }}
            id="orders"
          />
        ) : null}
        settings={(
          <AutoRefreshTable
            id="orders"
            getData={getOrders}
            sortDirection={sortDirection}
            sortField={sortField}
            searchText={searchText}
          />
        )}
      />
      <div className="orders-list-table">
        <TableComponent
          shouldRenderFields={true}
          applySort={sortField => applySort( sortField )}
          orders={orders}
          actionCallback={(useState) => {
            if (useState) {
              getOrders( meta.current_page, sortField, sortDirection, searchText )
            } else {
              getOrders()
            }
          }}
        />
      </div>
      <div className="orders-list-pagination">
        <Paginator
          meta={meta}
          settings={(
            <RowsPerPage
              changeRowsPerPage={(rowsPerPage) => {
                setRowsPerPage(rowsPerPage);
              }}
              id="orders"
            />
          )}
          changePage={page => getOrders( page, sortField, sortDirection, searchText, true )}
        />
      </div>
    </div>
  )
}

const OrderTable = connect( null, {
  showSpinner,
  hideSpinner
} )( OrderTableComponent );

export { OrderTable, OrderTableComponent };
